



































import { WebhookEventModel } from '@/app/shared/models';
import { refsService } from '@/app/shared/refs.service';
import { Component, Prop, Vue } from 'vue-property-decorator';
import { DataTableHeader } from 'vuetify';
import DialogWebhookEventDetails from '@/app/shared/components/dialogs/webhook-event-details.vue';

@Component({
  components: {
    DialogWebhookEventDetails,
  },
})
export default class DataTableWebhookEventsComponent extends Vue {
  @Prop(Object) readonly data!: object;

  private headers: DataTableHeader[] = [];
  private dialog = false;
  private loading = false;

  private get refs() {
    return refsService;
  }

  private get webhookEventList(): WebhookEventModel[] {
    return this.refs.modules.contract.webhookEventList;
  }

  private created(): void {
    this.headers = [
      { text: this.$t('headers.event_type').toString(), value: 'EventType' },
      { text: this.$t('headers.status').toString(), value: 'Status' },
      {
        text: this.$t('headers.result_status_code').toString(),
        value: 'ResultStatusCode',
      },
      {
        text: this.$t('headers.result_error_message').toString(),
        value: 'ResultErrorMessage',
      },
      { text: this.$t('headers.send_date').toString(), value: 'Created' },
      { text: '', value: 'Actions', sortable: false, align: 'end' },
    ];
  }

  private loadWebhookEvent(webhookEvent: WebhookEventModel) {
    this.loading = true;
    this.refs.modules.contract.SET_WEBHOOK_EVENT(webhookEvent);
    this.dialog = true;
    this.loading = false;
  }
}
